//
//
//
//
//
//

import { formartRoute } from '@/utils/util';
export default {
  props: {
    vote: {
      type: Object,
      default: null,
    },
    topicName: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
  },

  methods: {
    goToTopicDetail() {
      // 链接去除域名
      const link = formartRoute(this.link);
      window.location.href = link;
    },
  },
};
